Drupal.behaviors.menuAnimations = {
  attach: function (context) {
    // elements
    const header = document.querySelector(".header");
    const headerInner = document.querySelector(".header__inner");

    const url = getCurrentURL();

    let lastScrollPosition = sessionStorage.getItem("lastScrollPosition");
    // variable that decides if current page is "program-calendar", if true header will behave differently
    let isProgramCalendarPage = urlIsProgramCalendar();
    let ready = true;
    let hideFullHeaderIsActive = false;
    let showFullHeaderIsActive = false;

    // get the current url
    function getCurrentURL() {
      return window.location.href;
    }

    // check if current URL contains "program-calendar"
    function urlIsProgramCalendar() {
      if (url.includes("program-calendar")) {
        return true;
      } else {
        return false;
      }
    }

    function showFullHeader() {
      if (!showFullHeaderIsActive) {
        ready = false;
        showFullHeaderIsActive = true;
        hideFullHeaderIsActive = false;
        headerInner.style.display = "flex";

        header.classList.remove("header--out-animation");
        header.classList.add("header--full", "header--in-animation");

        // allow animation to complete
        setTimeout(() => {
          ready = true;
        }, 500);
      }
    }

    function hideFullHeader() {
      if (!hideFullHeaderIsActive) {
        showFullHeaderIsActive = false;
        hideFullHeaderIsActive = true;

        header.classList.remove("header--in-animation", "header--full");
        header.classList.add("header--out-animation");
      }
    }

    // if on a bigger screen than 900px, add scroll event listener
    if (window.innerWidth > 900) {
      document.addEventListener("scroll", () => {
        if (ready) {
          // if current scroll position is more than last scroll position, and is not program calendar page
          if (
            lastScrollPosition < window.scrollY &&
            lastScrollPosition > 50 &&
            !isProgramCalendarPage
          ) {
            hideFullHeader();
          } else if (lastScrollPosition > 50 && !isProgramCalendarPage) {
            showFullHeader();
          } else if (window.scrollY > 1 && isProgramCalendarPage) {
            hideFullHeader();
          }
          // only show full header when scrolled to top of page
          else if (window.scrollY < 1 && isProgramCalendarPage) {
            showFullHeader();
          }
        }

        lastScrollPosition = window.scrollY;
        sessionStorage.setItem("lastScrollPosition", lastScrollPosition);
      });
    }
  },
};
